import { INIT_FILTERS, SELECT_FILTER,
    FILTER_PLACES, UPDATE_FILTER } from './../actions/FilterAction';

const defaultState = {
    filters : null,
    tags    : null,
    selected: null
};

const filter = (state = defaultState, action) => {
    let newState;
    switch(action.type)
    {
        case INIT_FILTERS:
            newState = { ...state,
                filters: action.filters,
                tags   : action.tags
            };
            break;
        case FILTER_PLACES:
        case UPDATE_FILTER:
            newState = { ...state,
                filters: action.filters
            };
            break;
        case SELECT_FILTER:
            return {...state,
                selected: action.selected
            };
        default:
            newState = state;
    }

    return newState;
};

export default filter;


// WEBPACK FOOTER //
// ./src/reducers/FilterReducer.js